import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import AppSections from "../utils/AppSections";
import E3Ds from "../ui/e3ds/E3ds";
import E3dDetails from "../ui/e3ds/E3dDetails";
import E3dAddEdit from "../ui/e3ds/E3dAddEdit";
import _3D_INSTANCE_ADD_EDIT from "../ui/_3d_instances/_3dInstanceAddEdit";
import ConditionReportAddEdit from "../ui/condition_reports/ConditionReportAddEdit";
import ConditionReportCreateChoice from "../ui/condition_reports/ConditionReportCreateChoice";
import AnnexDataAddEdit from "../ui/annexdata/AnnexDataAddEdit";
import AnnexDataChemiTools from "../ui/annexdata/AnnexDataChemiTools";

const E3DsRoutes = (
  <Route
    path={AppSections.E3DS}
    element={
      <ProtectedRoute>
        <E3Ds />
      </ProtectedRoute>
    }
  >
    <Route path=":id/view" element={<E3dDetails />} />
    <Route path=":id/edit" element={<E3dAddEdit />} />

    {/* 3dinstances routes */}
    <Route
      path=":e3did/e3dinstances/create"
      element={<_3D_INSTANCE_ADD_EDIT />}
    />
    <Route
      path=":e3did/:chelementID/condition-reports/create"
      element={<ConditionReportCreateChoice />}
    />
    <Route
      path=":e3did/condition-reports/new"
      element={<ConditionReportAddEdit editCopy={false} />}
    />
    <Route
      path=":e3did/condition-reports/:cid/copy"
      element={<ConditionReportAddEdit editCopy={true} />}
    />
    <Route
      path=":e3did/condition-reports/:cid/edit"
      element={<ConditionReportAddEdit editCopy={false} />}
    />

    {/* documents routes */}
    <Route path=":e3did/annexdata/create" element={<AnnexDataAddEdit />} />
    {/* dedicated route for ChemiTools to display the documents list */}
    <Route path=":e3did/annexdata" element={<AnnexDataChemiTools />} />
  </Route>
);

export default E3DsRoutes;
